import {
  CivilCaseAppeald,
  CivilCaseEvidence,
  CivilCasePowerOfAgency,
  CivilCaseResolutions,
  CivilCaseResolutionsFeedback,
  CivilCaseWitness,
} from "types";
import apiClient from "../lib/apiClients";

// Witness
export const fetchCivilCaseWitness = async () => {
  const response = await apiClient.get<CivilCaseWitness[]>(
    "/complaint_handling/witnesses/",
  );
  return response.data;
};
export const addCivilCaseWitness = async (data: any) => {
  const response = await apiClient.post("/complaint_handling/witnesses/", data);
  return response.data;
};
export const editCivilCaseWitness = async (data: any) => {
  const response = await apiClient.put(
    "/complaint_handling/witnesses/" + data?.id + "/",
    data,
  );
  return response.data;
};
export const deleteCivilCaseWitness = async (data: CivilCaseWitness) => {
  const response = await apiClient.delete(
    "/complaint_handling/witnesses/" + data?.id + "/",
  );
  return response.data;
};

// Evidence
export const fetchCivilCaseEvidence = async () => {
  const response = await apiClient.get<CivilCaseEvidence[]>(
    "/complaint_handling/evidence/",
  );
  return response.data;
};
export const addCivilCaseEvidence = async (data: any) => {
  const response = await apiClient.post("/complaint_handling/evidence/", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};
export const editCivilCaseEvidence = async (data: any) => {
  const response = await apiClient.put(
    "/complaint_handling/evidence/" + data?.id + "/",
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};
export const deleteCivilCaseEvidence = async (data: CivilCaseEvidence) => {
  const response = await apiClient.delete(
    "/complaint_handling/evidence/" + data?.id + "/",
  );
  return response.data;
};

// PowerOfAgency
export const fetchCivilCasePowerOfAgency = async () => {
  const response = await apiClient.get<CivilCasePowerOfAgency[]>(
    "/complaint_handling/power-of-agency/",
  );
  return response.data;
};
export const addCivilCasePowerOfAgency = async (data: any) => {
  const response = await apiClient.post(
    "/complaint_handling/power-of-agency/",
    data,
  );
  return response.data;
};
export const editCivilCasePowerOfAgency = async (data: any) => {
  const response = await apiClient.put(
    "/complaint_handling/power-of-agency/" + data?.id + "/",
    data,
  );
  return response.data;
};
export const deleteCivilCasePowerOfAgency = async (
  data: CivilCasePowerOfAgency,
) => {
  const response = await apiClient.delete(
    "/complaint_handling/power-of-agency/" + data?.id + "/",
  );
  return response.data;
};

// Resolution
export const fetchCivilCaseResolution = async () => {
  const response = await apiClient.get<CivilCaseResolutions[]>(
    "/complaint_handling/resolutions/",
  );
  return response.data;
};
export const addCivilCaseResolution = async (data: any) => {
  const response = await apiClient.post(
    "/complaint_handling/resolutions/",
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};
export const editCivilCaseResolution = async (data: any) => {
  const response = await apiClient.patch(
    "/complaint_handling/resolutions/" + data?.id + "/",
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};
export const editCivilCaseResolution2 = async (data: any) => {
  const response = await apiClient.patch(
    "/complaint_handling/resolutions/" + data?.id + "/",
    data,
  );
  return response.data;
};
export const deleteCivilCaseResolution = async (data: CivilCaseResolutions) => {
  const response = await apiClient.delete(
    "/complaint_handling/resolutions/" + data?.id + "/",
  );
  return response.data;
};

// Appeal
export const fetchCivilCaseAppeal = async () => {
  const response = await apiClient.get<CivilCaseAppeald[]>(
    "/complaint_handling/appealed-complaints/",
  );
  return response.data;
};
export const fetchCivilCaseAppealByAdminAndOrg = async (
  admin_unit: string | number,
  isRegistrar: boolean = false,
) => {
  const url = isRegistrar
    ? `/complaint_handling/appealed-complaints/filter_by_admin_unit/?admin_unit_id=${admin_unit}`
    : `/complaint_handling/appealed-complaints/`;
  const response = await apiClient.get<CivilCaseAppeald[]>(url);
  return response.data;
};
export const fetchCivilCaseAppealById = async (id: string) => {
  const response = await apiClient.get<CivilCaseAppeald>(
    `/complaint_handling/appealed-complaints/${id}/`,
  );
  return response.data;
};
export const addCivilCaseAppeal = async (data: any) => {
  const response = await apiClient.post(
    "/complaint_handling/appealed-complaints/",
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};
export const editCivilCaseAppeal = async (data: any) => {
  const response = await apiClient.patch(
    "/complaint_handling/appealed-complaints/" + data?.id + "/",
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};
export const editCivilCaseAppeal2 = async (data: any) => {
  const response = await apiClient.patch(
    "/complaint_handling/appealed-complaints/" + data?.id + "/",
    data,
  );
  return response.data;
};
export const deleteCivilCaseAppeal = async (data: CivilCaseAppeald) => {
  const response = await apiClient.delete(
    "/complaint_entity/appeals/" + data?.id + "/",
  );
  return response.data;
};

// Feedback
export const fetchCivilCaseFeedback = async () => {
  const response = await apiClient.get<CivilCaseResolutionsFeedback[]>(
    "/complaint_handling/resolution-feedbacks/",
  );
  return response.data;
};
export const addCivilCaseFeedback = async (data: any) => {
  const response = await apiClient.post(
    "/complaint_handling/resolution-feedbacks/",
    data,
  );
  return response.data;
};
export const editCivilCaseFeedback = async (data: any) => {
  const response = await apiClient.patch(
    "/complaint_handling/resolution-feedbacks/" + data?.id + "/",
    data,
  );
  return response.data;
};
